<script setup lang="ts">

import { computed, useSlots } from "vue";

const label = computed( () => 
{
    const slots = useSlots();
    const content = String( slots.default!()[0].children );
    if( content == null || content.length == 0 ) return '-';
    else if( content.startsWith( '1' ) ) return `${content.slice( 0, 4 ) } ${ content.slice( 4, 10 )}`;
    return `${content.slice( 0, 2 ) } ${ content.slice( 2, 6 )} ${ content.slice( 6, 10 )}`
})

</script>

<template>
    <span class="whitespace-nowrap">{{ label }}</span>
</template>